import React from 'react'

const InspectionTrainingDivision = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Inspection & Training Division </h3>
              <div className="service-nr-list">
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Lifting and Heavy Equipment Inspection</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Mobile Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Crawler Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Lifting Appliance.
                      </li>

                      <li>
                        <i className="fal fa-check" /> EOT Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Elevators / Escalators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Marine & Offshore Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Storage Retrieval
                        Machines.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Articulating Boom Cranes.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list ">
                      <li>
                        <i className="fal fa-check" /> Lifting / Spreader Beams.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Powered Platforms.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Sky Climbers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Building Maintenance
                        Unit.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Vehicle Mounted
                        Elevating.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Man Baskets / Material
                        Basket.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fixed Cranes & Hoists.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Side Boom & Tractor.
                      </li>

                      <li>
                        <i className="fal fa-check" /> A-Frame & Mobile Gantry.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Tower Crane / Boom Truck.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Load Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Mobile Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Crawler Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> EOT Cranes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Spreader Beam.
                      </li>

                      <li>
                        <i className="fal fa-check" /> BOP Hoist.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Super Sack Hoist.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Man Basket.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Material Baskets.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Earth Moving Equipment</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Rig Equipment Inspection
                        (Drilling Machines and Piling Machines).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Elevators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bulldozers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Backhoe Loaders.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Wheel Loaders.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Skid Steer Loaders.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Motor Graders.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list">
                      <li>
                        <i className="fal fa-check" /> Scrapers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Trenchers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dump Trucks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Track Loaders.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Compactors (Rollers).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Draglines.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pile Drivers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Hydraulic Hammer.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Operator Assessment and Certification</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Tele-handler & Forklift
                        Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Backhoe Loader Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bulldozer Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Excavator Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Roller Compactor
                        Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Wheel Loader Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dump Truck Operator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Cranes Operators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Industrial and
                        Construction Equipment.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Comprehensive HSEQ Training </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Rigger’s Training and
                        Certifications.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Scaffolding Erector and
                        Dismantler.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Scaffolding Inspector.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Scaffolding Supervisor /
                        Foreman.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fire Watcher.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fire Marshal.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fire Fighter.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Confined Space Training.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Defensive Driving.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Work At Height.
                      </li>

                      <li>
                        <i className="fal fa-check" /> First Aid, CPR, and AED.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Flag Man.
                      </li>

                      <li>
                        <i className="fal fa-check" /> NEBOSH.
                      </li>

                      <li>
                        <i className="fal fa-check" /> IOSH.
                      </li>
                      <li>
                        <i className="fal fa-check" /> OTHM.
                      </li>
                      <li>
                        <i className="fal fa-check" /> OSHA.
                      </li>
                      <li>
                        <i className="fal fa-check" /> PTW System Training.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Confined Space Entry and
                        Rescue.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Workplace Hazard (HIRA).
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Lockout Tagout Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ergonomics and Manual
                        Handling Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Rigging and Slinging
                        Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Electrical Safety
                        Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Spill Prevention
                        Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Waste Management
                        Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> ISO 14001 Lead Auditor
                        Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> ISO 9001 QMS Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Accident Incident
                        Investigation Training.
                      </li>

                      <li>
                        <i className="fal fa-check" /> ERT Training.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InspectionTrainingDivision